import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@/components/buttons/Button';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { cdnImage } from '@/utils/image-utils';
import { useApiV2Request } from '@/hooks/useApiV2Request';
import { useDispatch, useSelector } from 'react-redux';
import { selectMarketingConsents } from '@/store/selectors/consentsSelectors';
import ApiService from '@/shared/apiService';
import { getConsents } from '@/store/actions/consentsActions';

const RewardsWheelMarketingConsent = ({ closeModal }: { closeModal: () => void }) => {
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();
  const { request: saveConsents, loading: saveConsentsLoading } = useApiV2Request();
  const marketingConsents = useSelector(selectMarketingConsents);
  const dispatch = useDispatch();

  const handleCtaClick = () => {
    triggerGTag(GTagEvents.rewards_wheel_locked_cta_accept_marketing);
    const approvedConsents = marketingConsents.map(consent => {
      return {
        ConsentId: consent.ConsentId,
        Version: consent.Version,
        Consented: true,
      };
    });
    saveConsents(ApiService.saveConsents, approvedConsents, () => {
      dispatch(getConsents());
      closeModal();
    });
  };

  const handleBackClick = () => {
    triggerGTag(GTagEvents.rewards_wheel_locked_cta_reject_marketing);
    closeModal();
    navigate('/');
  };

  useEffect(() => {
    triggerGTag(GTagEvents.rewards_wheel_locked_shown);
  }, []);

  return (
    <div
      data-cy="rewards-wheel-locked-modal"
      className="relative rounded-xl overflow-hidden bg-rewardsWheelBg p-8"
    >
      <img
        src={cdnImage('rewards-wheel/rewards-wheel-hero-locked.png', {
          width: '350px',
          height: 'auto',
          dpr: '2',
        })}
        className="mx-auto"
        width="350px"
        alt={intl.formatMessage({ id: 'rewardReel.h1' })}
      />
      <div className="text-white max-w-sm flex flex-col items-center gap-4 mt-4">
        <div className="text-lg font-bold">
          {intl.formatMessage({ id: 'rewardsWheelLocked.title' })}
        </div>
        <div className="text-md">{intl.formatMessage({ id: 'rewardsWheelLocked.subtitle' })}</div>
        <div className="flex w-full flex-col gap-y-2">
          <Button
            data-cy="rewards-wheel-modal-locked-accept-button"
            isLoading={saveConsentsLoading}
            onClickHandler={handleCtaClick}
            btnType="primary"
            text={intl.formatMessage({ id: 'rewardsWheelLocked.cta.acceptAndSpin' })}
          />
          <Button
            disabled={saveConsentsLoading}
            onClickHandler={handleBackClick}
            btnType="secondary"
            text={intl.formatMessage({ id: 'rewardsWheelLocked.cta.backToHomepage' })}
          />
        </div>
      </div>
    </div>
  );
};

export default RewardsWheelMarketingConsent;
